import { Outlet } from "react-router-dom";
import { usePermissions } from "../../hooks/usePermissions";
import AccessRestricted from "./AccessRestricted";

const SellerGuard = () => {
  const { isSeller, groups } = usePermissions();

  if (!isSeller) {
    return <AccessRestricted debugInfo={`Grupos: ${JSON.stringify(groups)}`} />;
  }

  return <Outlet />;
};

export default SellerGuard;
